<template>
	<div class="wxpay">
		<!-- <img src="@/assets/images/login.png" alt="" class="wx-logo" /> -->
		<!-- <img src="@/assets/images/login.png" alt="" class="wx-logo" /> -->
		<div class="wx-container">
			<div v-if="!showMobileComponent" class="wx-box">
				<div class="qrcode" ref="qrCodeUrl"></div>
				<span>请打开微信扫码支付</span>
			</div>
			<div v-else class="wx-box">
				<span>正在查询订单...</span>
			</div>
			<div class="wx-order">
				<p>订单编号：<span id="orderSn">{{ payMsg.order_no || $route.query.order_no }}</span></p>
				<p>订单金额：<span id="payPrice">{{ payMsg.amount }}</span>元</p>
			</div>
		</div>
	</div>
</template>

<script>
import QRCode from 'qrcodejs2';
import { payQuery } from '@/apis/order';
export default {
	data() {
		return {
			payMsg: {},
			timer: null,
		};
	},
	created() {
		// if(!sessionStorage['payInfo']) return this.$router.go(-1);
		this.payMsg = sessionStorage['payInfo'] ? JSON.parse(sessionStorage['payInfo']) : {};

		this.checkOrderStatus();
		this.queryOrderResult()
	},
	mounted() {
		// PC端显示二维码 
    !this.showMobileComponent && new QRCode(this.$refs.qrCodeUrl, {
			text: this.payMsg.code_url,
			width: 220,
			height: 220,
			colorDark: '#000000',
			colorLight: '#ffffff',
			correctLevel: QRCode.CorrectLevel.H
		});
	},
	beforeDestroy() {
		// sessionStorage.removeItem('payInfo');
		clearInterval(this.timer);
	},
	methods: {
		// 查询订单支付结果
		queryOrderResult(){
			// 查询次数
			let count = 30;
			count--;
			this.timer = setInterval(() =>{
				if(count < 0){
					clearInterval(this.timer);
					// 支付失败
					this.$router.push({ path:'/pay/result', query:{ type: 2 }})
					// this.$router.push('/orders');
					return;
				}
				count--;
				this.checkOrderStatus();
			}, 5000);
		},
		checkOrderStatus(){
			payQuery({
				order_no: this.$route.query.order_no || this.payMsg.order_no,
			}).then(({ result }) => {
				if( result.exists ){
					clearInterval(this.timer);
					this.$useMessage({ type: 'success', message: '支付成功' });
					setTimeout(() => {
						this.$router.push({ path:'/pay/result', query:{ type: 1 }})
					}, 2000);
					return
				}
			})
		}
	}
};
</script>

<style scoped>
.wx-logo {
	position: absolute;
	left: 50%;
	top: 8%;
	margin-left: -105px;
}
.wx-container {
	width: 400px;
	padding-bottom: 40px;
	position: relative;
	margin: 0 auto;
	/* background: linear-gradient(105deg, rgb(63, 129, 210) 0%, rgb(47, 197, 85) 100%); */
	background: #D8271C;
	border-radius: 12px;
	overflow: hidden;
}
.wx-container .wx-box {
	width: 90%;
	margin: 5% auto;
	border-radius: 10px;
	background: #ffffff;
	padding-top: 30px;
	padding-bottom: 20px;
	position: relative;
	text-align: center;
}
.wx-container .wx-box img {
	width: 220px;
	height: 220px;
	position: absolute;
	left: 70px;
	top: 30px;
}
.wx-container .wx-box span {
	display: inline-block;
	width: 100%;
	text-align: center;
	color: #D8271C;
	font-size: 20px;
	font-weight: 500;
}
.wx-container .qrcode {
	text-align: center;
	margin: 0 auto;
	width: auto;
	display: inline-block;
	margin-bottom: 15px;
}
.wx-container .wx-order {
	padding-left: 5%;
	padding-top: 10px;
}
.wx-container .wx-order p {
	font-size: 18px;
	color: #ffffff;
	font-weight: 500;
	margin-bottom: 10px;
}
.wx-container .wx-order p span {
	color: #ffffff;
}
@media (max-width: 500px) {
	.wx-container{
		margin-top: 1rem;
		width: 345px;
	}
}
</style>
